<template>
    <CascoAjanlatBase :titleExtra="titleExtra"  v-if="true">

        <v-form slot="biztositoi-adatok" ref="casco-ajanlat-adatok">

            <v-layout row wrap>

                <BnFormField :attributes="uniqa_hasznalat_tipus" />

                <BnFormField :attributes="uniqa_kotes_oka" />

                <BnFormField :attributes="uniqa_jarmu_allapot" />

            </v-layout>

        </v-form>

    </CascoAjanlatBase>

</template>

<script>
import BnFormField from '../../../../../../../basecomponents/BnFormField.vue';
import CascoAjanlatBase from '../CascoAjanlatBase.vue';
import cascoOfferData from '../../../../../mixins/ajanlatiadatok/biztosito_specifikus/CascoOfferData';

export default {
    name: 'AjanlatAdatokB6_V0',
    mixins: [cascoOfferData],
    components: { CascoAjanlatBase, BnFormField },
    methods: {
/*
        uzlszemleVisible() {
            return parseInt(this.szemleTipus, 10) === 1;
        },
        szakszemleVisible() {
            return parseInt(this.szemleTipus, 10) === 2;
        },
        hianyzoSzemlVisible() {
            return parseInt(this.szemleTipus, 10) === 3;
*/
        uzlszemleVisible() {
            return parseInt(this.szemleTipus, 10) === 200;
        },
        kozvszemleVisible() {
            return parseInt(this.szemleTipus, 10) === 300;
        },
        szakszemlebiztVisible() {
            return parseInt(this.szemleTipus, 10) === 400;
        },
        szakszemlemeglVisible() {
            return parseInt(this.szemleTipus, 10) === 500;
        },
        hianyzoSzemlVisible() {
            return parseInt(this.szemleTipus, 10) === 100;
        },
        szemleChange() {
            this.szemleTipus = this.$store.getters.tarifaData.uniqa.tf_uniqa_szemle;
        },
    },
    mounted() {
        this.szemleTipus = this.$store.getters.tarifaData.uniqa.tf_uniqa_szemle;
    },
    data() {
        return {
            szemleTipus: null,
            uniqa_hasznalat_tipus: {
                type: 'select',
                label: 'Jármű használat típusa',
                visible: true,
                editable: true,
                help: true,
                mezo: 'uniqa.tf_uniqa_hasznalat_tipus',
                path: 'tarifaData.uniqa.tf_uniqa_hasznalat_tipus',
                itemsText: 'value',
                itemsValue: 'key',
                options: [
                    { key: '10', value: 'Csak magáncélra' },
                    { key: '20', value: 'Magán és üzleti célra' },
                    { key: '30', value: 'Csak üzleti célra' },
                ],
            },
            uniqa_kotes_oka: {
                type: 'select',
                label: 'CASCO kötés oka',
                visible: true,
                editable: true,
                help: true,
                mezo: 'uniqa.tf_uniqa_kotes_oka',
                path: 'tarifaData.uniqa.tf_uniqa_kotes_oka',
                itemsText: 'value',
                itemsValue: 'key',
/*
                options: [
                    { key: '10', value: 'Magyarországon vásárolt új, 0 km-es gépjárműre kötök' },
                    { key: '20', value: 'Magyarországon vásárolt használt gépjárműre kötök' },
                    {
                        key: '30',
                        value: 'Külföldről behozott és Magyarországon'
                            + ' először forgalomba helyezett gépjárműre kötök',
                    },
                    { key: '40', value: 'Előző szerződésem díjnemfizetés miatt szűnt meg' },
                    {
                        key: '50',
                        value: 'Folyamatos fedezettel nem rendelkező, '
                            + 'casco nélküli, használt gépjárműre kötök',
                    },
                    { key: '60', value: 'Szerződés évfordulóra történő átkötése' },
                    { key: '70', value: 'Előzmény szerződés évforduló előtti átdolgozása' },
                ],
*/
// 2024. szept. 19-től hatályos:
                options: [
                    { key: '220', value: 'Új, 0 km-es gépjárműre kötök' },
                    { key: '230', value: 'Használt gépjárműre kötök - első forgalomba helyezés Mo-n történt' },
                    { key: '250', value: 'Díjnemfizetés miatt megszűnt szerződés újrakötése' },
                    { key: '210', value: 'Évfordulós felmondással vagy közös megegyezéssel megszűnt szerződés újrakötése' },
                    { key: '240', value: 'Használt gépjárműre kötök - első forgalomba helyezés külföldön történt' },
                ],
            },
            uniqa_jarmu_allapot: {
                type: 'select',
                label: 'Jármű állapota',
                visible: true,
                editable: true,
                help: true,
                mezo: 'uniqa.tf_uniqa_jarmu_allapot',
                path: 'tarifaData.uniqa.tf_uniqa_jarmu_allapot',
                itemsText: 'value',
                itemsValue: 'key',
/*
                options: [
                    { key: '1', value: 'Sérülésmentes' },
                    { key: '2', value: 'Korábbi sérülés szakszerűen javított' },
                    { key: '3', value: 'Totálkárból helyreállított' },
                    { key: '4', value: 'Sérült' },
*/
// 2024. szept. 19-től hatályos:
                options: [
                    { key: '100', value: 'Sérülésmentes' },
                    { key: '200', value: 'Sérült' },
                    { key: '300', value: 'Sérülés szaksz. javítva' },
                    { key: '400', value: 'Totálkárból helyreállítva' },
                ],
            },
            uniqa_szemle: {
                type: 'select',
                label: 'Szemle típusa',
                visible: true,
                editable: true,
                help: true,
                mezo: 'uniqa.tf_uniqa_szemle',
                path: 'tarifaData.uniqa.tf_uniqa_szemle',
                itemsText: 'value',
                itemsValue: 'key',
/*
                options: [
                    { key: '1', value: 'Üzletkötői szemle' },
                    { key: '2', value: 'Szakértői szemle' },
                    { key: '3', value: 'Nincs szemle' },
                ],
*/
// 2024. szept. 19-től hatályos:
                options: [
                    { key: '100', value: 'Nincs szükség szemlére' },
                    { key: '200', value: 'Üzletkötői szemle' },
                    { key: '300', value: 'Biztosításközvetítői szemle' },
                    { key: '400', value: 'Dekra szemle, a biztosító rendeli meg az új folyamat részeként' },
                    { key: '500', value: 'Dekra szemle, a jelenlegi meglévő folyamatok szerint történik a megrendelése' },
                ],
                change: this.szemleChange,
            },
            uniqa_uzletk_szemle_datum: {
                type: 'date',
                label: 'Üzletkötői szemle dátuma',
                visible: true,
                editable: true,
                help: true,
                mezo: 'uniqa.tf_uniqa_uzletk_szemle_datum',
                path: 'tarifaData.uniqa.tf_uniqa_uzletk_szemle_datum',
            },
            uniqa_szakertoi_szemle_datum: {
                type: 'date',
                label: 'Szakértői szemle dátuma',
                visible: true,
                editable: true,
                help: true,
                mezo: 'uniqa.tf_uniqa_szakertoi_szemle_datum',
                path: 'tarifaData.uniqa.tf_uniqa_szakertoi_szemle_datum',
            },
            uniqa_hianyzo_szemle_text: {
                type: 'text',
                label: 'A hiányzó szemle indoklása',
                visible: true,
                editable: true,
                help: true,
                mezo: 'uniqa.tf_uniqa_hianyzo_szemle_text',
                path: 'tarifaData.uniqa.tf_uniqa_hianyzo_szemle_text',
            },
        };
    },
};
</script>
